var React = require('react');

function SortDown (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M279.07 224.05h-238c-21.4 0-32.1-25.9-17-41l119-119a23.9 23.9 0 0 1 33.8-.1l.1.1 119.1 119c15.07 15.05 4.4 41-17 41z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M296.07 329.05L177 448.05a23.9 23.9 0 0 1-33.8.1l-.1-.1-119-119c-15.1-15.1-4.4-41 17-41h238c21.37 0 32.04 25.95 16.97 41z","className":"fa-primary","key":2})]);
}

SortDown.defaultProps = {"viewBox":"0 0 320 512","className":"icon"};

module.exports = SortDown;

SortDown.default = SortDown;
